export default __webpack_public_path__ + "static/media/bg-1.f74a232e.jpg";